import Utility from "../../../helpers/paymentHelpers/utility";
import get from "lodash/get";
import LocalStorageFunc from "../../../helpers/paymentHelpers/localStorageFunc";
import {
  PAYMENT_ACTION,
  PAYMENT_GATEWAY,
  PAYMENT_METHOD,
  PAYMENT_STATUS,
  PAYMENT_TRANSACTION_URL,
  RESPONSE,
  DEFAULT_USER_EMAIL,
  common,
  UNIFIED_ACTION,
  SENTINEL,
  IS_INDIA,
} from "../../../helpers/paymentHelpers/paymentConstants";
import Headers from "../../../config/paymentConfig/headers";
import ApiCalls from "../../../config/paymentConfig/apiCalls";
import {
  keyMapsAction,
  keyMapsMutation,
} from "../../../helpers/paymentHelpers/storeKeys";
import { keyMapsGetter } from "../../../helpers/storeKeys";
import {
  EVENT_BEGIN_CHECKOUT,
  EVENT_CHECKOUT_PROGRESS,
  EVENT_ORDER_COMPLETED,
  EVENT_PRODUCT_PURCHASED,
} from "../../../helpers/analyticsEvents";
// import ampUtility from "../../../helpers/paymentHelpers/amplitude/ampUtility";
import { JSEncrypt } from "jsencrypt";

export default {
  namespaced: true,
  state: {
    submitLoader: false,
    isPlaceOrderActive: false,
    paymentMode: {},
    paymentModeTemp: {},
    currentPayloadForPaytm_pg: {},
    progressBarOnOrderSubmit: false,
    upiIntentConfig: {
      eventAction: "",
    },
    submitPaymentOrderResponse: {},
    showHtmlPaymentModal: false,
    submitHtmlResponse: "",
    selectedBankCvvData: { cardNumber: "" },
    binText: "WITHOUT_BIN",
    currentRadioId: "cancel-promo",
    scrollIdForPayment: "recommended-payment-mode-comp",
    call: {},
    reloadIconPageTimerObj: {
      st: () => {},
      nb: 1,
    },
  },
  getters: {},
  mutations: {
    updateScrollIdForPayment(state, payload) {
      state.scrollIdForPayment = payload;
    },
    updateCurrentRadioId(state, payload) {
      state.currentRadioId = payload;
    },
    updateBinText(state, payload) {
      state.binText = payload;
    },
    updateSelectedBankCvvData(state, payload) {
      state.selectedBankCvvData = payload;
    },
    updateSubmitLoader(state, payload) {
      state.submitLoader = payload;
    },
    updateIsPlaceOrderActive(state, payload) {
      state.isPlaceOrderActive = payload;
    },
    updatePaymentMode(state, payload) {
      state.paymentMode = payload;
    },
    updatePaymentModeTemp(state, payload) {
      state.paymentModeTemp = payload;
    },
    updateUpiIntentConfig(state, payload) {
      state.upiIntentConfig = payload;
    },
    updatePayloadForPaytm_pg(state, payload) {
      state.currentPayloadForPaytm_pg = payload;
    },
    updateProgressBarOnOrderSubmit(state, payload) {
      state.progressBarOnOrderSubmit = payload;
    },
    updateSubmitOrderResponse(state, payload) {
      state.submitPaymentOrderResponse = payload || {};
    },
    updateShowHtmlPaymentModal(state, payload) {
      state.showHtmlPaymentModal = payload;
    },
    updateSubmitHtmlResponse(state, payload) {
      state.submitHtmlResponse = payload;
    },
    updateCall(state, payload) {
      state.call = payload;
    },
  },
  actions: {
    checkRadioIdForPromo({ state, commit, rootState, dispatch }, payload) {
      const { id = "", value = "" } = payload;
      let popupCheck = id.split("-") || [""];
      let isSavedpopup = popupCheck[popupCheck.length - 1] == "savedpopup";
      commit("updateCall", value);
      let paymtOptn = get(
        rootState,
        "PriceDetail.cartData.explicitPromo.paymentOptions",
        []
      );
      if (paymtOptn?.length > 0) {
        if (id !== "cancel-promo") {
          if (value?.paymentMode == "CC" || value?.paymentMode == "DC") {
            if (
              value?.promos &&
              state.paymentModeTemp?.promos &&
              value?.promos[0]?.promoCode !==
                state.paymentModeTemp?.promos[0]?.promoCode
            ) {
              // in case of same promo code applied for two different savecard
              commit(keyMapsMutation.UPDATE_SAVE_CARD_BANK_MODAL, false, {
                root: true,
              });
              commit("updateCurrentRadioId", id);
            } else {
              dispatch("Wallet/toggleAllWalletModal", false, { root: true });
            }
          } else {
            commit(keyMapsMutation.UPDATE_NET_BANKING_MODAL, false, {
              root: true,
            });
            dispatch("Wallet/toggleAllWalletModal", false, { root: true });
            commit("updateCurrentRadioId", id);
          }
          document.body.classList.remove("body-stop-scroll-mobile");
        }
        if (value?.paymentMode == "CC" || value?.paymentMode == "DC") {
          if (
            value?.promos &&
            state.paymentModeTemp?.promos &&
            value?.promos[0]?.promoCode !==
              state.paymentModeTemp?.promos[0]?.promoCode
          ) {
            // in case of same promo code applied for two different savecard
            commit(keyMapsMutation.UPDATE_SAVE_CARD_BANK_MODAL, false, {
              root: true,
            });
            commit("updateCurrentRadioId", id);
          }
        } else {
          commit("updateCurrentRadioId", id);
        }
        if (!isSavedpopup) commit("updateCurrentRadioId", id);
      }
    },
    allOtherModalCloseWhileError({ commit }) {
      document.body.classList.remove("body-stop-scroll-mobile");
      commit("GiftCardAndEvoucher/updateEvoucheModalOpen", false, {
        root: true,
      });
      // commit("GiftCardAndEvoucher/updateGiftCardModalOpen", false, { root: true })
    },
    toggleHtmlPaymentModal({ commit, state, dispatch }, payload) {
      if (payload) {
        document.body.classList.add("body-stop-scroll-mobile");
      } else {
        document.body.classList.remove("body-stop-scroll-mobile");
      }
      commit("updateShowHtmlPaymentModal", payload);
    },
    setPaymentModeInit({ commit, state }, payload) {
      try {
        commit("updatePaymentModeTemp", payload);
        commit("updatePaymentMode", payload);
        commit("updateIsPlaceOrderActive", true);
      } catch (err) {}
    },
    setPaymentMode({ commit, state }, payload) {
      try {
        commit("updatePaymentModeTemp", payload);
        commit("updatePaymentMode", payload);
        commit("updateIsPlaceOrderActive", true);
        //set payment mode in localstorage
        if (payload.paymentId) {
          //set name key as paymentId localstorege to support old PWA
          payload.name = payload.paymentId;
        } else if (payload.paymentMode) {
          //set name key as paymentMode localstorege to support old PWA
          payload.name = payload.paymentMode;
        }
        //set label in case of saved card to support old PWA
        if (payload.cardId) {
          let label = "Credit Card";
          if (payload.paymentMode && payload.paymentMode === "DC")
            label = "Debit Card";
          payload.label = label;
        }
        LocalStorageFunc.setPaymentMode(payload);
      } catch (err) {
        console.log(err);
      }
    },
    setPaymentModeTemp({ commit, rootState, state, dispatch }, payload) {
      try {
        let paymtOptn = get(
          rootState,
          "PriceDetail.cartData.explicitPromo.paymentOptions",
          []
        );
        // check if promo is applied
        let isPayUsingOther = get(
          rootState,
          "CreditDebit.PayUsingOtherPaymentModeTrue",
          false
        );
        let explicitPromo = get(
          rootState,
          "PriceDetail.cartData.explicitPromo",
          false
        );

        if (paymtOptn?.length > 0) {
          if (state.binText === "WITHOUT_BIN") {
            if (explicitPromo && isPayUsingOther) {
              //remove the promo code if payment option is changed
              if (
                payload?.cardId == undefined &&
                (payload?.paymentMode == "CC" || payload?.paymentId == "CC")
              ) {
                // when explicit promo code is there then we no need to show remove promo code modal for that reason we have added this condition to prevent to open explicit promo code modal
                commit(keyMapsMutation.UDPATE_IS_REMOVE_PROMO, false, {
                  root: true,
                });
              } else {
                if (
                  explicitPromo.promoCode &&
                  state.call.promos &&
                  explicitPromo.promoCode == state.call.promos[0]?.promoCode
                ) {
                  commit("updatePaymentModeTemp", payload);
                } else {
                  commit(keyMapsMutation.UDPATE_IS_REMOVE_PROMO, true, {
                    root: true,
                  });
                  commit(
                    "ErrorModal/updateCurrentSelectForChangePaymentModeForBinOffer",
                    payload,
                    { root: true }
                  );
                  commit(
                    keyMapsMutation.UPDATE_REMOVE_PROMO_CODE,
                    explicitPromo,
                    { root: true }
                  );
                }
              }
            }
          } else {
            commit("updatePaymentModeTemp", payload);
          }
          commit(keyMapsMutation.UPDATE_IS_APPLY_PROMO_BUTTON_ACTIVE, false, {
            root: true,
          });
        } else {
          let paymObj = {};
          if (payload?.cardId !== undefined && payload?.cardId) {
            paymObj = { ...payload, paymentId: "CC", paymentMode: "CC" };
            commit("updatePaymentModeTemp", paymObj);
          } else {
            commit("updatePaymentModeTemp", payload);
            if (payload.paymentMode == "CASH") {
              let tipData = get(
                rootState,
                "PriceDetail.cartData.tip.tipAmount",
                0
              );
              if (tipData > 0) {
                dispatch("PriceDetail/getCartApiCall", payload, { root: true });
              }
            }
          }
          commit("updateIsPlaceOrderActive", true);
          commit(keyMapsMutation.UPDATE_SAVED_CARD_CVV, {}, { root: true });
        }
      } catch (err) {
        dispatch("openErrorModalFun", { isPopOpen: true });
      }
    },
    navigateOnPaymentMode({ commit, state, dispatch }, data) {
      let response = data.response;
      let payload = data.payload;
      let resPayload = null;
      switch (response.gateway) {
        case PAYMENT_GATEWAY.RAZORPAY:
          // handle Razorpay PG
          LocalStorageFunc.setOrderTransactionId(response.orderTransactionId);
          if (response.next && response.next[0].action == "otp_submit") {
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            commit("CreditDebit/saveRazorpayResponse", response, {
              root: true,
            });
            dispatch(keyMapsAction.TOGGLE_ENTER_CARD_OTP_MODAL, true, {
              root: true,
            });
            // ampUtility.screenViewAmpEvents({
            //   Page_Name:'confirm_otp',
            //   previousScreenname: 'payment_lp'}
            // );
          } else if (response.next && response.next[0].action == "redirect") {
            dispatch(
              keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
              { action: "Redirect", pAction: "RAZORPAY", pg: "RAZORPAY" },
              { root: true }
            );
            let redirectUrl = response.next[0].url;
            window.location.href = redirectUrl; //goto razorpay page for payment
          }
          break;
        case PAYMENT_GATEWAY.PAYU:
          // handle PayU PG
          resPayload = response.payuPayload;
          for (const key in resPayload) {
            resPayload[key.toLowerCase()] = resPayload[key];
          }

          if (
            response.paymentId === PAYMENT_METHOD.CREDIT_CARD ||
            response.paymentId === PAYMENT_METHOD.DEBIT_CARD
          ) {
            resPayload = {
              ...resPayload,
              ccnum: get(payload, "query.query.cardDetail.cardNumber", 0),
              ccvv: get(payload, "query.query.cardDetail.cvv", 0),
              ccexpyr: get(payload, "query.query.cardDetail.year", 0),
              ccexpmon: get(payload, "query.query.cardDetail.month", ""),
              ccname: get(payload, "query.query.cardDetail.name", ""),
            };
          }
          dispatch(
            keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
            { action: "Redirect", pAction: "PAYU", pg: "PAYU" },
            { root: true }
          );
          Utility.postFormData(response.processTransactionURL, resPayload);
          break;
        case PAYMENT_GATEWAY.PAYTM_PG:
          // handle Paytm PG
          resPayload = response.paytmPayload;
          if (
            response.paymentId === PAYMENT_METHOD.CREDIT_CARD ||
            response.paymentId === PAYMENT_METHOD.DEBIT_CARD
          ) {
            if (payload?.query?.query?.cardDetail?.cardId) {
              resPayload.cardInfo = `${get(
                payload,
                "query.query.cardDetail.cardId",
                ""
              )}||${get(payload, "query.query.cardDetail.cvv", "")}|`;
            } else {
              resPayload.cardInfo = `|${get(
                payload,
                "query.query.cardDetail.cardNumber",
                ""
              )}|${get(payload, "query.query.cardDetail.cvv", "")}|${get(
                payload,
                "query.query.cardDetail.month",
                ""
              )}${get(payload, "query.query.cardDetail.year", "")}`;
            }
          }

          if (response?.paymentId === PAYMENT_METHOD.UPI_WALLET) {
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            dispatch(
              keyMapsAction.UPI_WALLET_PAYMENT_GATEWAY_ACTION,
              response || {},
              { root: true }
            ); // Calling UPi wallet function
            commit("updateSubmitOrderResponse", response || {});
          } else {
            dispatch(
              keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
              { action: "Redirect", pAction: "PAYTM_PG", pg: "PAYTM_PG" },
              { root: true }
            );
            Utility.postFormData(response.processTransactionURL, resPayload);
          }
          break;
        case PAYMENT_GATEWAY.BILLDESK:
          // handle Billdesk
          commit("updateSubmitHtmlResponse", response.initiateHtml || "");
          dispatch(
            keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
            { action: "Redirect", pAction: "BILLDESK", pg: "BILLDESK" },
            { root: true }
          );
          dispatch("toggleHtmlPaymentModal", true);
          break;
        case PAYMENT_GATEWAY.GLOBALPAY:
          // handle Globalpay
          dispatch(
            keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
            { action: "Redirect", pAction: "GLOBALPAY", pg: "GLOBALPAY" },
            { root: true }
          );
          Utility.postFormData(
            response.globalpayUrl,
            response.globalpayPayload
          );
          break;
        case PAYMENT_GATEWAY.SSLCOMMERZ:
          // handle SSL
          dispatch(
            keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
            { action: "Redirect", pAction: "SSLCOMMERZ", pg: "SSLCOMMERZ" },
            { root: true }
          );
          Utility.postFormData(response.processTransactionURL, {});
          break;
        case PAYMENT_GATEWAY.PAYTM_WALLET:
          resPayload = response.action;
          commit("updateProgressBarOnOrderSubmit", false);
          Utility.wantToDisabledToAllScreenForSubmit(false);
          if (resPayload === PAYMENT_ACTION.PROCESS_PAYMENT) {
            dispatch(
              keyMapsAction.TOGGLE_REDEEM_PAYTM_WALLET_MODAL_ACTION,
              { response, payload, action: true },
              { root: true }
            );
          }
          break;
        default:
          commit("updateProgressBarOnOrderSubmit", false);
          Utility.wantToDisabledToAllScreenForSubmit(false);
          break;
      }
      setTimeout(() => {
        commit("updateProgressBarOnOrderSubmit", false);
        Utility.wantToDisabledToAllScreenForSubmit(false);
      }, 6000);
    },
    paymentGateway({ commit, rootState, state, dispatch, rootGetters }, data) {
      const cartDetails =
        rootGetters[keyMapsGetter.GET_CART_DETAILS_FOR_ANALYTICS];

      const { validItems, itemIds, quantity, itemPrice } = cartDetails;
      let isSavedAddress = "No";
      const selectedAddress = LocalStorageFunc.getSelectedAddress();
      if (selectedAddress?.address_id) {
        isSavedAddress = "Yes";
      }
      try {
        let response = data.responseGateway;
        let payload = data.payloadGateway;
        let paymentDetail = data.paymentDetail;
        const orderTransactionId = get(
          payload,
          "query.query.urlParam.$transactionId",
          ""
        );
        switch (response.action) {
          case PAYMENT_ACTION.UNIFIED_PAYMENT:
            //unified payment
            dispatch("proceedToUnifiedPayment", {
              response,
              payload,
              paymentDetail,
            });
            break;
          case PAYMENT_ACTION.PROCESS_PAYMENT:
            dispatch("navigateOnPaymentMode", { response, payload });
            break;
          case PAYMENT_ACTION.THANKYOU:
            //Navigate to thank you page
            dispatch(
              keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
              { action: "Success" },
              { root: true }
            );
            commit(
              "GiftCardAndEvoucher/updateEvoucherThankYouResponse",
              response,
              { root: true }
            );
            Utility.sendToThankYouScreen(orderTransactionId);
            break;
          case PAYMENT_ACTION.REMOVE_PROMO:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            commit("ErrorModal/updateNotApplicablePromoData", true, {
              root: true,
            }); // open the modal
            commit("PriceDetail/updateNotApplicablePromoActive", true, {
              root: true,
            }); // to set the active key as true until this process get finished
            commit(
              "ErrorModal/updateNotApplicableResponse",
              response?.removePromoPayload,
              { root: true }
            ); // set the data in store
            break;
          case PAYMENT_ACTION.COD_OTP:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            dispatch(
              keyMapsAction.GET_COD_OTP,
              { orderTransactionId },
              { root: true }
            );
            break;
          case PAYMENT_ACTION.EV_OTP:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            commit("GiftCardAndEvoucher/updateGiftOrEvoucher", "GIFT_CARD", {
              root: true,
            });
            break;
          case PAYMENT_ACTION.EV_PIN:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            //WE HAVE TO SHOW THE TOTAL AMOUT WILL DIDUCT AFTER E-VOUCHER IS APPLIED
            if (
              rootState.GiftCardAndEvoucher.evoucherCard.evoucherPinResponse &&
              Object.keys(
                rootState.GiftCardAndEvoucher.evoucherCard.evoucherPinResponse
              ).length !== 0
            ) {
              // commit("GiftCardAndEvoucher/updateEvoucheModalOpen", false, {root: true});
              // document.body.classList.remove("body-stop-scroll-mobile");
              commit("GiftCardAndEvoucher/updateEvoucherScreen", "EVOUCHER", {
                root: true,
              });
            } else {
              commit(
                "GiftCardAndEvoucher/updateEvoucherScreen",
                "VOUCHER-AMOUNT",
                { root: true }
              );
            }
            commit("GiftCardAndEvoucher/updateEvoucherIsDisableKey", false, {
              root: true,
            });
            commit("GiftCardAndEvoucher/updateEvoucherResponse", response, {
              root: true,
            });
            break;
          case PAYMENT_ACTION.PAYTM_LINK:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            // Link Paytm wallet Call
            commit(keyMapsMutation.UPDATE_SHOW_LINK_PAYTM_WALLET, true, {
              root: true,
            });
            dispatch(keyMapsAction.TOGGLE_PAYTM_LINK_MODAL_ACTION, true, {
              root: true,
            });
            break;
          case PAYMENT_ACTION.PAYTM_ADD_MONEY:
            // Add money in paytm wallet case
            commit(keyMapsMutation.UPDATE_PAYTM_WALLET_RESPONSE, response, {
              root: true,
            });
            dispatch(
              keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
              {
                action: "Redirect",
                pAction: "PAYTM_ADD_MONEY",
                pg: "PAYTM_PG",
              },
              { root: true }
            );
            Utility.postFormData(
              response.processTransactionURL,
              response.paytmWalletPayload
            );
            break;
          default:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            break;
        }
        setTimeout(() => {
          commit("updateProgressBarOnOrderSubmit", false);
          Utility.wantToDisabledToAllScreenForSubmit(false);
        }, 6000);

        EVENT_CHECKOUT_PROGRESS({
          itemName: validItems,
          itemSku: itemIds,
          quantity,
          price: itemPrice,
          addressSaved: isSavedAddress,
          address: selectedAddress,
          paymentMethodSaved: payload.paymentMode ? "Yes" : "No",
          paymentMethod: payload.paymentMode || "NA",
          checkoutOption: "Payment Method",
          checkoutStep: 3,
          checkoutStage: "payment initiated",
        });
      } catch (err) {
        EVENT_CHECKOUT_PROGRESS({
          itemName: validItems,
          itemSku: itemIds,
          quantity,
          price: itemPrice,
          addressSaved: isSavedAddress,
          address: selectedAddress,
          paymentMethodSaved: payload.paymentMode ? "Yes" : "No",
          paymentMethod: payload.paymentMode || "NA",
          checkoutOption: "Payment Method",
          checkoutStep: 3,
          checkoutStage: "payment initiation failed",
        });
        console.error("Error in paymentGateway", err);
        dispatch("openErrorModalFun", { isPopOpen: true });
        commit("updateProgressBarOnOrderSubmit", false);
        Utility.wantToDisabledToAllScreenForSubmit(false);
      }
    },
    /**
     * If non logged in, directly navigate to the OTP page for cash
     * Else, hit the specified payment gateway.
     */
    proceedToPaymentAPI({ commit, rootState, state, dispatch }, payload) {
      const { response, paymentId, paymentMode, isLoggedIn, paymentDetail } =
        payload;
      const { cartId } = response.confirmOrderBatchResponse.cartResponse;
      const responseGateway = response.initiateOrderPaymentResponse;
      const { orderTransactionId } = response.initiateOrderPaymentResponse;
      LocalStorageFunc.setOrderTransactionId(orderTransactionId);
      const payloadGateway = {
        type: "SUBMIT_ORDER",
        query: {
          data: {
            cartId,
            orderTransactionId,
            primaryPaymentId: paymentId,
            transactionStatusUrl: `${window.location.origin}${PAYMENT_TRANSACTION_URL}`,
          },
          query: {
            urlParam: {
              $transactionId: orderTransactionId,
            },
          },
          paymentType: {
            name: paymentMode,
          },
        },
      };

      if (paymentDetail?.instrumentDetails?.cardId) {
        payloadGateway.query.query.cardDetail = {
          cardId: paymentDetail?.instrumentDetails?.cardId,
          cvv: rootState.CreditDebit.savedCardCvv.cvv,
        };
      } else if (paymentDetail?.instrumentDetails?.card) {
        let cardObj = paymentDetail?.instrumentDetails?.card
          ? paymentDetail.instrumentDetails.card
          : {};
        payloadGateway.query.query.cardDetail = {
          cardNumber: get(cardObj, "number", 0),
          cvv: get(cardObj, "cvv", 0),
          year: "20" + get(cardObj, "expiry_year", 0),
          month: get(cardObj, "expiry_month", ""),
          name: get(cardObj, "name", ""),
        };
      }

      dispatch("paymentGateway", {
        responseGateway,
        payloadGateway,
        paymentDetail,
      });
    },
    /**
     * Submit order API call
     */
    postSubmitOrder({ commit, rootState, state, dispatch, rootGetters }, data) {
      try {
        const cartDetails =
          rootGetters[keyMapsGetter.GET_CART_DETAILS_FOR_ANALYTICS];
        const cartViewCharges =
          rootGetters[keyMapsGetter.GET_CART_CALCULATIONS_FOR_ANALYTICS];

        const {
          validItems,
          itemIds,
          totalCartAmt,
          quantity,
          itemPrice,
          totalQuantity,
          invalidItemsInCart,
          invalidItemsName,
          isComboCart,
          isVegCart,
        } = cartDetails;

        let isSavedAddress = "No";

        const cartId = LocalStorageFunc.cartId();
        const selectedAddress = LocalStorageFunc.getSelectedAddress();
        if (selectedAddress?.address_id) {
          isSavedAddress = "Yes";
        }
        Utility.wantToDisabledToAllScreenForSubmit(true); // for adding disabled feature while call submit order
        let latestAddress = get(data, "address[0]", {});
        const advanceTime = LocalStorageFunc.getStorageValue("advancedTime");
        const advanceStore = LocalStorageFunc.getStorageValue("advanceStore");
        if (advanceTime && advanceStore) {
          latestAddress = { ...latestAddress, storeCode: advanceStore };
        }
        let paymentDetail;
        let isWalletUsed;
        let totalWalletBalance = 0;
        let cartData = get(rootState, "PriceDetail.cartData", {});
        const isLoggedIn = data.isLoggedIn;
        if (IS_INDIA) {
          isWalletUsed = LocalStorageFunc.getIsWalletUsed();
          totalWalletBalance = Utility.getTotalWalletBalance(cartData);
        }
        const priceToBePaid = Utility.getPriceToBePaid(data);
        //tips changes for submit call
        const tipAmountFromStore = Utility.deliveryTipAmountSelector(cartData);
        const tipCheckboxValue =
          Utility.getSessionStorageValue("TIP_CHECKBOX_VALUE");
        const tip = {
          tipAmount: tipAmountFromStore || "0",
          autoTipSelected: tipCheckboxValue,
        };
        let paymentId = Utility.getPaymentId(state.paymentModeTemp);
        if (data.primaryPaymentId) {
          paymentId = data.primaryPaymentId;
        }
        const paymentMode = Utility.getPaymentMode(state.paymentModeTemp);
        if (isWalletUsed && priceToBePaid === 0) {
          //Case : Complete payment is made by wallet
          paymentDetail = {
            primaryPaymentId: PAYMENT_METHOD.CITRUS_WALLET,
            transactionStatusUrl: `${window.location.origin}${PAYMENT_TRANSACTION_URL}`,
            loyaltyEligible: !!IS_INDIA,
          };
        } else {
          paymentDetail = {
            primaryPaymentId: paymentId,
            secondaryPaymentId:
              isWalletUsed && totalWalletBalance > 0 //Case : secondaryPaymentId is send as 'PIGGYBANK' (wallet)
                ? PAYMENT_METHOD.CITRUS_WALLET // when some wallet is selected to made some part of payment
                : null, // else send as null
            transactionStatusUrl: `${window.location.origin}${PAYMENT_TRANSACTION_URL}`,
            loyaltyEligible: false,
            cartId: data.globalData.cartId,
          };
          if (data?.cardInitialDigits)
            paymentDetail.cardInitialDigits = data?.cardInitialDigits;
          if (data?.instrumentDetails)
            paymentDetail.instrumentDetails = data?.instrumentDetails;
          if (data?.secondaryPaymentId)
            paymentDetail.secondaryPaymentId = data?.secondaryPaymentId;
        }

        let headersObj = {};
        const miniApp = LocalStorageFunc.getIsMiniApp();
        if (miniApp) {
          let vendorConfig = get(
            rootState,
            "Global.pwaConfig.vendorConfig",
            null
          );
          if (typeof vendorConfig === "string") {
            vendorConfig = JSON.parse(vendorConfig);
          }
          paymentId = get(vendorConfig, `${miniApp}.primaryPaymentId`, "");
          paymentDetail = {
            primaryPaymentId: paymentId,
            transactionStatusUrl: `${window.location.origin}${PAYMENT_TRANSACTION_URL}`,
          };
        } else {
          headersObj["gps_enabled"] =
            LocalStorageFunc.getIsLocationPermisssionGiven();
        }
        if (LocalStorageFunc.getDiscountAllocationError()) {
          headersObj["has_invalid_coupon"] = true;
        }
        const options = {
          data: {
            orderDetails: {
              address: latestAddress,
              cartId: data.globalData.cartId,
              deliveryType: data.globalData.delType,
              price: data.globalData.displayPrice || 0,
              userDetails: data.userDetails,
              zeroContactDelivery: data.globalData.zeroContactDelivery,
              partnerUserId: LocalStorageFunc.getPartnerUserId(),
              tip,
              advancedTime: advanceTime > 0 ? `${advanceTime}` : "",
              optedOptionalCharges: data.optedOptionalCharges, //TBD
            },
            paymentDetails: { ...paymentDetail },
          },
          urlParam: {
            userId: data.globalData.userId,
          },
        };

        if (data.globalData.deliveryInstructions) {
          options.data.orderDetails.deliveryInstructions =
            data.globalData.deliveryInstructions;
        }

        if (data.edvMixMatchData) {
          options.data.edvMixMatchData = data.edvMixMatchData;
        }

        if (data.edvMixMatchPrice) {
          options.data.edvMixMatchPrice = data.edvMixMatchPrice;
        }

        if (data.enroll) {
          options.data.orderDetails.enroll = data.enroll;
          options.data.orderDetails.loyaltyRegistrationRequest =
            data.loyaltyRegistrationRequest;
        }

        headersObj = {
          ...headersObj,
          ...Headers(),
          ...LocalStorageFunc.utmAttributesSelector(),
          feedback_variant: "HomeScreenFeedbackWidget",
          variant: "unified",
        };
        commit("updateProgressBarOnOrderSubmit", true);
        const {
          cardScheme = "",
          issuerDisplayName = "",
          label = "",
        } = state.paymentModeTemp;
        // ampUtility.dynamicAmplitudeEvent('payment_attempt', {
        //   eventAction: 'payment_attempt',
        //   eventLabel: label,
        //   paymentMode: paymentMode,
        //   paymentId: paymentId,
        //   bankName: issuerDisplayName,
        //   cardType: cardScheme,
        //   Page_Name: "payment_lp",
        //   previousScreenname: "cart"
        // });

        ApiCalls.POST_SUBMIT_ORDER_API({
          headers: headersObj,
          payload: options,
        })
          .then((response) => {
            if (response?.data) {
              LocalStorageFunc.updateTip({});
              LocalStorageFunc.updateCouponCode("");
              LocalStorageFunc.setSelectedListUpSellItems({});
              LocalStorageFunc.setTipAutomaticallySelected(false);
              if (
                get(response, "data.status", "") === RESPONSE.FAILED ||
                response.data.errors ||
                response.data.errorMessage
              ) {
                const {
                  displayMsg = "",
                  btnMsg = "",
                  header = "",
                  code = "",
                } = response?.data?.errors[0] || {};
                let obj = {
                  bodyMsg: displayMsg,
                  headerMsg: header,
                  delayTime: 20000,
                  isPopOpen: true,
                };
                dispatch("allOtherModalCloseWhileError");
                dispatch("openErrorModalFun", obj);
                commit("updateProgressBarOnOrderSubmit", false);
                Utility.wantToDisabledToAllScreenForSubmit(false);
                // ampUtility.dynamicAmplitudeEvent('submit_error', {
                //   errormsg: 'Submit Error Failed ' + displayMsg,
                //   Page_Name: "payment_lp",
                //   previousScreenname: "cart"
                // });
              } else {
                // ampUtility.checkoutProgressAmpEvent(response?.data, state.paymentModeTemp);
                dispatch("proceedToPaymentAPI", {
                  response: response?.data,
                  paymentId,
                  paymentMode,
                  isLoggedIn,
                  paymentDetail,
                });
                Utility.setStoreAndLocation(response.data);
                if (
                  response?.data?.confirmOrderBatchResponse?.cartResponse
                    ?.cartCalculations
                ) {
                  const { cartResponse } =
                    response?.data?.confirmOrderBatchResponse;
                  cartResponse.strikePrice = cartResponse.displayNetPrice;
                  Utility.saveCartSuccess(cartResponse);
                  commit(
                    "PriceDetail/updateCartCalculations",
                    cartResponse.cartCalculations,
                    { root: true }
                  );
                  commit("PriceDetail/updateCartData", cartResponse, {
                    root: true,
                  });
                  commit(
                    "PriceDetail/updateValidItems",
                    get(cartResponse, "validItems", []),
                    { root: true }
                  );
                  commit(
                    "Global/updateDisplayPrice",
                    cartResponse.strikePrice,
                    { root: true }
                  );
                }
              }
            } else {
              Utility.wantToDisabledToAllScreenForSubmit(false); // for remove disabled feature while call submit order
              const {
                displayMsg = "",
                btnMsg = "",
                header = "",
                code = "",
              } = response?.errors[0] || {};
              let obj = {
                bodyMsg: displayMsg,
                headerMsg: header,
                delayTime: 20000,
                isPopOpen: true,
              };

              // Error Handing According to paymentMode
              //Evoucher error codes
              //"1.EVINSUFBAL" - "Insufficient balance available in voucher. Please use other payment option"
              //"1.EVINVCRD" - "Could not find card. Please enter valid card number."
              //"1.EVERROR" - "Either card number or card pin is incorrect."
              //"1.EVERROR" - "Your card has been temporarily deactivated for the day due to multiple attempts with invalid PIN. Please retry tomorrow."
              if (paymentMode == "CASH" && code == "2.WRGOTP") {
                // FOR CASH OTP ERROR
                commit("Cash/updateCashErrorOtpMsg", displayMsg, {
                  root: true,
                });
              }

              if (code == "1.EVINVCRD" || code == "1.EVINSUFBAL") {
                if (paymentMode == "EVOUCHER") {
                  commit(
                    "GiftCardAndEvoucher/updateEvoucherErrorMsg",
                    displayMsg,
                    { root: true }
                  );
                  commit(
                    "GiftCardAndEvoucher/updateEvoucherIsDisableKey",
                    false,
                    { root: true }
                  );
                } else if (paymentMode == "GIFTCARD") {
                  commit(
                    "GiftCardAndEvoucher/updateEvoucherErrorMsg",
                    displayMsg,
                    { root: true }
                  );
                  commit(
                    "GiftCardAndEvoucher/updateEvoucherIsDisableKey",
                    false,
                    { root: true }
                  );
                }
              } else {
                dispatch("allOtherModalCloseWhileError");
                dispatch("openErrorModalFun", obj);
              }
              commit("updateProgressBarOnOrderSubmit", false);
              // ampUtility.dynamicAmplitudeEvent('submit_error', {
              //   errormsg: 'Submit Error ' + displayMsg,
              //   Page_Name: "payment_lp",
              //   previousScreenname: "cart"
              // });
            }
            LocalStorageFunc.deleteAdvanceOrderTimeStampKey();
          })
          .catch((error) => {
            dispatch("allOtherModalCloseWhileError");
            setTimeout(() => {
              dispatch("openErrorModalFun", { isPopOpen: true });
            }, 500);
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            // ampUtility.dynamicAmplitudeEvent('submit_error', {
            //   errormsg: 'Submit Error catch - ' + error,
            //   Page_Name: "payment_lp",
            //   previousScreenname: "cart"
            // });
          });
      } catch (err) {
        dispatch("allOtherModalCloseWhileError");
        setTimeout(() => {
          dispatch("openErrorModalFun", { isPopOpen: true });
        }, 500);
        commit("updateProgressBarOnOrderSubmit", false);
        Utility.wantToDisabledToAllScreenForSubmit(false);
        // ampUtility.dynamicAmplitudeEvent('submit_error', {
        //   errormsg: 'Submit Error final catch - ' + err,
        //   Page_Name: "payment_lp",
        //   previousScreenname: "cart"
        // });
      }
    },
    /**
     * init place order call to prep the submit order payload
     */
    initPlaceOrder(
      { commit, rootState, state, dispatch, rootGetters },
      payload
    ) {
      //
      const lastLocation = LocalStorageFunc.getLastLocationNew();
      const recentLocation = get(lastLocation, "[0].recent", {});
      const recentStoreCoord = get(lastLocation, "[0].location", {});
      //
      const cartInfo = rootState.PriceDetail.cartData || {};
      const wallet = get(cartInfo, "wallet", {});
      const strikePrice = get(cartInfo, "strikePrice", null);
      const displayPrice = get(cartInfo, "displayNetPrice", null);
      const cartData = get(cartInfo, "validItems", []);
      //
      const userInfo = LocalStorageFunc.getUserData();
      const userData = get(userInfo, "userData", {});
      const userId = get(userInfo, "headers.userId", {});
      const headerCartId = get(userInfo, "headers.cartId", {});
      //
      const addressDetail = LocalStorageFunc.getAddressDetail();
      const mobile = get(addressDetail, "mobNo", "") || userData.mobile;
      let addressInfo = {};
      const selectedAddress = LocalStorageFunc.getSelectedAddress();

      let saveAddressPayload = {
        latitude:
          get(recentStoreCoord, "latitude", "") ||
          get(recentLocation, "latitude", ""),
        longitude:
          get(recentStoreCoord, "longitude", "") ||
          get(recentLocation, "longitude", ""),
        mobile_no: mobile,
        building_number:
          get(selectedAddress, "houseNo", "") ||
          get(addressDetail, "houseNo", ""),
        address_component: get(recentLocation, "addressComponent", ""),
        storeCode: get(recentLocation, "id", ""),
        street_name:
          get(selectedAddress, "address", "") ||
          get(addressDetail, "address", ""),
      };
      //
      const allUserAddresses = LocalStorageFunc.getUserAddresses();
      let matchAddress = Utility.isAddressAvailable(
        allUserAddresses,
        recentLocation,
        recentStoreCoord
      );
      const isLoggedIn = LocalStorageFunc.isLoggedIn();
      if (isLoggedIn && matchAddress) {
        (saveAddressPayload.building_number = get(
          matchAddress,
          "building_number",
          ""
        )),
          (saveAddressPayload.customer_address_name = get(
            matchAddress,
            "customer_address_name",
            ""
          )),
          (saveAddressPayload.street_name = get(
            matchAddress,
            "street_name",
            ""
          ));
      }

      if (!saveAddressPayload.address_component) {
        delete saveAddressPayload.address_component;
        if (isLoggedIn && matchAddress) {
          addressInfo = {
            city: get(matchAddress, "city", ""),
            city_region: get(matchAddress, "city_region", ""),
            area_level0: get(matchAddress, "area_level0", ""),
            area_level1: get(matchAddress, "area_level1", ""),
            area_level2: get(matchAddress, "area_level2", ""),
            latitude:
              get(recentLocation, "latitude", "") ||
              get(recentStoreCoord, "latitude", ""),
            longitude:
              get(recentLocation, "longitude", "") ||
              get(recentStoreCoord, "longitude", ""),
          };
        } else {
          addressInfo = {
            city:
              get(recentLocation, "city", "") ||
              get(recentStoreCoord, "city", ""),
            city_region:
              get(recentLocation, "city_region", "") ||
              get(recentLocation, "name", "") ||
              get(recentStoreCoord, "locality", ""),
            area_level0:
              get(recentLocation, "sub_locality", "") ||
              get(recentLocation, "area_level0", "") ||
              get(recentStoreCoord, "sub_locality", ""),
            area_level1:
              get(recentLocation, "area_level1", "") ||
              get(recentStoreCoord, "area1", ""),
            area_level2:
              get(recentLocation, "area_level2", "") ||
              get(recentStoreCoord, "area2", ""),
            latitude:
              get(recentLocation, "latitude", "") ||
              get(recentStoreCoord, "latitude", ""),
            longitude:
              get(recentLocation, "longitude", "") ||
              get(recentStoreCoord, "longitude", ""),
          };
        }
      }

      saveAddressPayload = { ...saveAddressPayload, ...addressInfo };

      const isCarryBagSelected =
        Utility.getSessionStorageValue("CARRY_BAG_CHECKBOX_SELECTED") || false;
      const extraCharges = {
        optedOptionalCharges: [
          {
            chargeTypeCode: "K",
            selected: isCarryBagSelected,
          },
        ],
      };

      const data = {
        address: [saveAddressPayload],
        userDetails: {
          firstName:
            get(addressDetail, "fName", "") || get(userData, "firstName", ""),
          lastName:
            get(addressDetail, "lName", "") || get(userData, "lastName", ""),
          mobile,
          email: get(
            addressDetail,
            "email",
            get(userData, "email", DEFAULT_USER_EMAIL)
          ),
        },
        globalData: {
          userId,
          cartId: headerCartId,
          delType: rootState.Address.deliveryType,
          displayPrice,
          strikePrice,
        },
        isSaveAddress: false,
        isLoggedIn,
        isAddressOnCart: true,
        wallet,
        ...extraCharges,
      };

      // EDV MIX MATCH submit order additional 2 params.
      const edvMixAndmatch = Utility.edvMixMatchDataPrice(cartData);

      if (edvMixAndmatch) {
        data.edvMixMatchData = edvMixAndmatch.edvMixMatchData.join("|");
        data.edvMixMatchPrice = `PRM-${edvMixAndmatch.edvMixMatchPrice.join(
          ","
        )}`;
      }
      const irctcData = LocalStorageFunc.getIsIrctc();
      if (!irctcData) {
        data.globalData.zeroContactDelivery =
          LocalStorageFunc.getZeroContactDelivery();
        data.globalData.deliveryInstructions =
          LocalStorageFunc.getOptedDelvryInsructns().join(". ");
      }

      const loyaltyInfo = Utility.tryJsonParse(
        LocalStorageFunc.getLoyaltyInfo()
      );
      const loyaltyCardCode = get(loyaltyInfo, "loyaltyCardCode", "");
      const optedChessyRewardEnroll = Utility.getSessionStorageValue(
        "enrollCartWidgetCheckboxSet"
      );
      if (optedChessyRewardEnroll) {
        data.enroll = true;
        data.loyaltyRegistrationRequest = {
          loyaltyCardCode,
        };
      }

      if (payload?.instrumentDetails) {
        data.instrumentDetails = payload.instrumentDetails;
        data.instrumentDetails.isSecure = false;
      }
      if (payload?.cardInitialDigits) {
        data.cardInitialDigits = payload.cardInitialDigits;
      }
      if (payload?.primaryPaymentId) {
        data.primaryPaymentId = payload.primaryPaymentId;
      }
      if (payload?.paymentMode) {
        data.paymentMode = payload.paymentMode;
      }
      if (payload?.secondaryPaymentId) {
        data.secondaryPaymentId = payload.secondaryPaymentId;
      }

      // init checkout event
      const cartDetails =
        rootGetters[keyMapsGetter.GET_CART_DETAILS_FOR_ANALYTICS];

      const { validItems, itemIds, quantity, itemPrice } = cartDetails;

      let isSavedAddress = "No";
      if (selectedAddress?.address_id) {
        isSavedAddress = "Yes";
      }
      EVENT_BEGIN_CHECKOUT({
        itemName: validItems,
        itemSku: itemIds,
        quantity,
        price: itemPrice,
        addressSaved: isSavedAddress,
        address: [saveAddressPayload],
        paymentMethodSaved: payload.paymentMode ? "Yes" : "No",
        paymentMethod: payload.paymentMode || "NA",
      });
      EVENT_CHECKOUT_PROGRESS({
        itemName: validItems,
        itemSku: itemIds,
        quantity,
        price: itemPrice,
        addressSaved: isSavedAddress,
        address: [saveAddressPayload],
        paymentMethodSaved: payload.paymentMode ? "Yes" : "No",
        paymentMethod: payload.paymentMode || "NA",
        checkoutOption: "Select Address",
        checkoutStep: 2,
        checkoutStage: "checkout initiated",
      });
      if (
        SENTINEL.IS_GET_SENTINELIZED &&
        payload.paymentMode &&
        (payload.paymentMode === "CC" || payload.paymentMode === "DC")
      ) {
        dispatch("getSentinelized", data);
      } else {
        dispatch("postSubmitOrder", data);
      }
    },

    getSentinelized({ commit, state, dispatch }, payload) {
      let submitCall = false;
      try {
        setTimeout(() => {
          if (!submitCall) {
            submitCall = true;
            dispatch("postSubmitOrder", payload);
          }
        }, SENTINEL.SENTINELIZED_TIMEOUT);
        let queryObj = {};
        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(SENTINEL.PUBLIC_KEY);
        const B64 = Utility.Base64;
        if (payload?.instrumentDetails?.card?.number) {
          const cardObj = payload.instrumentDetails?.card || {};
          queryObj.instrumentDetails = {
            card: {
              number: B64._utf8_encode(encrypt.encrypt(cardObj.number)),
              cvv: B64._utf8_encode(encrypt.encrypt(cardObj.cvv)),
              expiry_month: B64._utf8_encode(
                encrypt.encrypt(cardObj.expiry_month)
              ),
              expiry_year: B64._utf8_encode(
                encrypt.encrypt(cardObj.expiry_year)
              ),
              name: cardObj.name || "",
            },
            saveCard: payload.instrumentDetails?.saveCard,
          };
        } else {
          const savedCardObj = payload.instrumentDetails?.card || {};
          queryObj.instrumentDetails = {
            card: {
              cvv: B64._utf8_encode(encrypt.encrypt(savedCardObj.cvv)),
            },
            cardId: payload.instrumentDetails.cardId,
            saveCard: payload.instrumentDetails?.saveCard,
          };
        }
        ApiCalls.GET_SENTINELIZED_API({
          headers: {
            ...Headers(),
            clientId: SENTINEL.CLIENT_ID,
            clientSecret: SENTINEL.CLIENT_SECRET,
          },
          payload: queryObj,
        })
          .then(function (response) {
            if (response?.data && response?.data?.instrumentDetails) {
              if (!submitCall) {
                submitCall = true;
                payload.instrumentDetails = response.data.instrumentDetails;
                payload.instrumentDetails.isSecure = true;
                dispatch("postSubmitOrder", payload);
              }
            } else {
              if (!submitCall) {
                submitCall = true;
                dispatch("postSubmitOrder", payload);
              }
            }
          })
          .catch(function (error) {
            console.log("ERROR in SENTINELIZED...", error);
            if (!submitCall) {
              submitCall = true;
              dispatch("postSubmitOrder", payload);
            }
          });
      } catch (err) {
        console.log("ERROR in SENTINELIZED", err);
        if (!submitCall) {
          submitCall = true;
          dispatch("postSubmitOrder", payload);
        }
      }
    },

    pollingActionHandler({ commit, rootState, state, dispatch }, data) {
      try {
        const { response, payload, paymentDetail } = data;
        switch (response.paymentId) {
          case PAYMENT_METHOD.UPI_WALLET:
            //upiflow  - "COLLECT" or "INTENT"
            let upiFlow =
              paymentDetail?.instrumentDetails?.upiPaymentDetailsDto?.upiflow ||
              "COLLECT";
            if (upiFlow === "COLLECT") {
              commit("updateProgressBarOnOrderSubmit", false);
              Utility.wantToDisabledToAllScreenForSubmit(false);
              dispatch(
                keyMapsAction.UPI_COLLECT_FLOW_POLLING,
                { payload: response, upiType: upiFlow } || {},
                { root: true }
              );
              // commit("updateSubmitOrderResponse", response || {})
            } else if (upiFlow === "INTENT") {
              commit("updateProgressBarOnOrderSubmit", false);
              Utility.wantToDisabledToAllScreenForSubmit(false);
              dispatch(
                keyMapsAction.UPI_COLLECT_FLOW_POLLING,
                { payload: response, upiType: upiFlow } || {},
                { root: true }
              );
            }
            break;
          default:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            break;
        }
      } catch (err) {
        console.error("Error in Polling Action Handler", err);
        dispatch("openErrorModalFun", { isPopOpen: true });
        commit("updateProgressBarOnOrderSubmit", false);
        Utility.wantToDisabledToAllScreenForSubmit(false);
      }
    },
    intentActionHandler({ commit, rootState, state, dispatch }, data) {
      try {
        const { response, payload, paymentDetail, unifiedActions } = data;
        switch (response.paymentId) {
          case PAYMENT_METHOD.UPI_WALLET:
            if (
              unifiedActions &&
              unifiedActions.intent &&
              unifiedActions.intent.url
            ) {
              if (unifiedActions && unifiedActions.poll) {
                dispatch("pollingActionHandler", {
                  response,
                  payload,
                  paymentDetail,
                });
                window.open(unifiedActions.intent.url);
              } else {
                let errorObj = {
                  bodyMsg:
                    "Something went wrong with polling. Please retry after sometime or use another payment option",
                  headerMsg: "",
                  delayTime: 20000,
                  isPopOpen: true,
                };
                commit("updateProgressBarOnOrderSubmit", false);
                Utility.wantToDisabledToAllScreenForSubmit(false);
                dispatch("openErrorModalFun", errorObj);
                // ampUtility.upiFailureEventAmp({
                //   eventAction: "PAYMENT_VERIFY_SERVICE_ERROR",
                //   eventCategory: "UPI Failure",
                //   eventLabel: ""
                // });
              }
            } else {
              let errorObj = {
                bodyMsg:
                  "Deeplink not recieved from PG. Please retry after sometime or use another payment option",
                headerMsg: "",
                delayTime: 20000,
                isPopOpen: true,
              };
              commit("updateProgressBarOnOrderSubmit", false);
              Utility.wantToDisabledToAllScreenForSubmit(false);
              dispatch("openErrorModalFun", errorObj);
              // ampUtility.upiFailureEventAmp({
              //   eventAction: "DEEPLINK_ERROR",
              //   eventCategory: "UPI Failure",
              //   eventLabel: ""
              // });
            }
            break;
          default:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            break;
        }
      } catch (err) {
        console.error("Error in Polling Action Handler", err);
        dispatch("openErrorModalFun", { isPopOpen: true });
        commit("updateProgressBarOnOrderSubmit", false);
        Utility.wantToDisabledToAllScreenForSubmit(false);
      }
    },
    otpActionHandler({ commit, rootState, state, dispatch }, data) {
      try {
        const { response, payload, paymentDetail } = data;
        const paymentObj = rootState.PaymentSubmit?.paymentModeTemp || {};
        const { cardId = "" } = paymentObj;
        switch (response.paymentId) {
          case PAYMENT_METHOD.CREDIT_CARD:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            commit("CreditDebit/saveUnifiedResponse", response || {}, {
              root: true,
            });
            dispatch(keyMapsAction.TOGGLE_ENTER_CARD_OTP_MODAL, true, {
              root: true,
            });
            // ampUtility.screenViewAmpEvents({
            //   Page_Name:'confirm_otp',
            //   previousScreenname: cardId ? 'payment_lp' : 'add_new_card'}
            // );
            break;
          case PAYMENT_METHOD.DEBIT_CARD:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            commit("CreditDebit/saveUnifiedResponse", response || {}, {
              root: true,
            });
            dispatch(keyMapsAction.TOGGLE_ENTER_CARD_OTP_MODAL, true, {
              root: true,
            });
            // ampUtility.screenViewAmpEvents({
            //   Page_Name:'confirm_otp',
            //   previousScreenname: cardId ? 'payment_lp' : 'add_new_card'}
            // );
            break;
          default:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            break;
        }
      } catch (err) {
        console.error("Error in OTP Action Handler", err);
        dispatch("openErrorModalFun", { isPopOpen: true });
        commit("updateProgressBarOnOrderSubmit", false);
        Utility.wantToDisabledToAllScreenForSubmit(false);
      }
    },
    redirectUtil({ commit, rootState, state, dispatch }, redirectAction) {
      try {
        // ampUtility.dynamicAmplitudeEvent('unified_payment_redirect', {
        //   type: redirectAction.content ? 'formPost' : 'url',
        //   Page_Name: "payment_lp",
        //   previousScreenname: "cart"
        // });
        if (redirectAction.content) {
          Utility.postFormData(redirectAction.url, redirectAction.content);
        } else {
          window.location.href = redirectAction.url; //redirect to PG's page for payment
        }
      } catch (err) {
        console.error("Error in Redirect UTIL", err);
        dispatch("openErrorModalFun", { isPopOpen: true });
        commit("updateProgressBarOnOrderSubmit", false);
        Utility.wantToDisabledToAllScreenForSubmit(false);
      }
    },
    redirectActionHandler({ commit, rootState, state, dispatch }, data) {
      try {
        const { response, payload, paymentDetail, unifiedActions } = data;
        switch (response.paymentId) {
          case PAYMENT_METHOD.NET_BANKING:
            dispatch("redirectUtil", unifiedActions[UNIFIED_ACTION.REDIRECT]);
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            break;
          default:
            dispatch("redirectUtil", unifiedActions[UNIFIED_ACTION.REDIRECT]);
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            break;
        }
      } catch (err) {
        console.error("Error in redirect Action Handler", err);
        dispatch("openErrorModalFun", { isPopOpen: true });
        commit("updateProgressBarOnOrderSubmit", false);
        Utility.wantToDisabledToAllScreenForSubmit(false);
      }
    },
    /**
     * Unified payment processing modal
     */
    proceedToUnifiedPayment({ commit, rootState, state, dispatch }, data) {
      try {
        const { response, payload, paymentDetail } = data;
        const unifiedResponse = response.unifiedPaymentResponse || {};
        const unifiedActions = unifiedResponse.nextActions || {};
        // ampUtility.dynamicAmplitudeEvent('unified_payment', {
        //   action: unifiedActions.action || '',
        //   Page_Name: "payment_lp",
        //   previousScreenname: "cart"
        // });
        switch (unifiedActions.action) {
          case UNIFIED_ACTION.INTENT:
            dispatch("intentActionHandler", {
              response,
              payload,
              paymentDetail,
              unifiedActions,
            });
            break;
          case UNIFIED_ACTION.POLL:
            dispatch("pollingActionHandler", {
              response,
              payload,
              paymentDetail,
            });
            break;
          case UNIFIED_ACTION.OTP:
            dispatch("otpActionHandler", { response, payload, paymentDetail });
            break;
          case UNIFIED_ACTION.REDIRECT:
            dispatch("redirectActionHandler", {
              response,
              payload,
              paymentDetail,
              unifiedActions,
            });
            break;
          default:
            commit("updateProgressBarOnOrderSubmit", false);
            Utility.wantToDisabledToAllScreenForSubmit(false);
            break;
        }
      } catch (err) {
        console.error("Error in unified payment", err);
        dispatch("openErrorModalFun", { isPopOpen: true });
        commit("updateProgressBarOnOrderSubmit", false);
        Utility.wantToDisabledToAllScreenForSubmit(false);
      }
    },
    /**
     * Payment Submit order API call - in case of CASH OTP
     */
    paymentSubmitOrder({ commit, rootState, state, dispatch }, payload) {
      try {
        const { removePromo, confirmOrderConfig, query, data, paymentType } =
          payload.query;
        commit("updateProgressBarOnOrderSubmit", true);
        let response;
        ApiCalls.PAYMENT_SUBMIT_ORDER_API({
          headers: Headers(),
          payload: payload,
        })
          .then((res) => {
            if (res?.data) {
              response = res?.data;
              switch (response.status) {
                case RESPONSE.SUCCESS:
                  const responseGateway = response;
                  const payloadGateway = payload;
                  dispatch("paymentGateway", {
                    responseGateway,
                    payloadGateway,
                  });
                  break;
                case RESPONSE.FAILED:
                  {
                    const responseGateway = response;
                    const payloadGateway = payload;
                    dispatch("paymentGateway", {
                      responseGateway,
                      payloadGateway,
                    });
                    const errMsg = response && response.errors[0];
                    const data = {
                      bodyMsg: errMsg.displayMsg,
                      headerMsg: errMsg.header,
                      delayTime: 20000,
                      isPopOpen: true,
                    };
                    dispatch("openErrorModalFun", data);
                  }
                  break;
                default:
                  const errObj = {
                    bodyMsg: common.internalServerError,
                    headerMsg: common.ops,
                    delayTime: 20000,
                    isPopOpen: true,
                  };
                  dispatch("openErrorModalFun", errObj, { root: true });
                  break;
              }
            } else {
              const {
                displayMsg = "",
                btnMsg = "",
                header = "",
              } = response?.errors[0] || {};
              let obj = {
                bodyMsg: displayMsg,
                headerMsg: header,
                delayTime: 20000,
                isPopOpen: true,
              };
              dispatch("openErrorModalFun", obj);
            }
          })
          .catch((error) => {
            console.log("resposnse of submit...", error);
            dispatch("openErrorModalFun", { isPopOpen: true });
          });
      } catch (err) {
        console.error("ERROR on submit order saga", err);
      } finally {
        commit("updateProgressBarOnOrderSubmit", false);
      }
    },

    getChargeStatus({ commit, state, dispatch }, payload) {
      const {
        prcsTranURL,
        prcsTranPayload,
        paytm_pgPayload,
        orderTransactionId,
      } = payload;
      try {
        ApiCalls.GET_CHARGE_API({
          headers: Headers(),
          payload: paytm_pgPayload,
        })
          .then((response) => {
            if (response?.data) {
              if (response?.data?.url !== undefined) {
                dispatch("getTransactionStatusApi", {
                  response: response?.data?.request,
                  url: response?.data?.url,
                  prcsTranPayload: prcsTranPayload,
                  prcsTranURL: prcsTranURL,
                  orderTransactionId: orderTransactionId,
                  paytm_pgPayload: paytm_pgPayload,
                });
              }
            }
          })
          .catch((error) => {
            console.log(" 13 13 13 13 13 -- UPI Error...", error);
            commit(keyMapsMutation.UPDATE_CIRCLE_RELOAD_MODAL, false, {
              root: true,
            });
            dispatch("openErrorModalFun", { isPopOpen: true });
          });
      } catch (err) {
        console.log(" 14 14 14 14 14 -- ssdfd", err);
        commit(keyMapsMutation.UPDATE_CIRCLE_RELOAD_MODAL, false, {
          root: true,
        });
        dispatch("openErrorModalFun", { isPopOpen: true });
      }
    },
    getProcessTransactionApi({ commit, state, dispatch }, pay) {
      const { url, payload, paytm_pgPayload, orderTransactionId } = pay;
      try {
        ApiCalls.PROCESS_TRANSACTION_API({
          headers: Headers(),
          payload: payload,
          url: url,
        })
          .then((res) => {
            if (res?.data?.body) {
              const { deepLink = "" } = res?.data?.body?.deepLinkInfo;
              if (deepLink?.length > 0 && deepLink?.length !== undefined) {
                window.open(deepLink);
                dispatch("getChargeStatus", {
                  prcsTranURL: url,
                  prcsTranPayload: payload,
                  paytm_pgPayload: paytm_pgPayload,
                  orderTransactionId: orderTransactionId,
                });
              } else {
                let errorObj = {
                  bodyMsg:
                    "Deeplink not recieved from Paytm. Please retry after sometime or use another payment option",
                  headerMsg: "",
                  delayTime: 20000,
                  isPopOpen: true,
                };
                commit(keyMapsMutation.UPDATE_CIRCLE_RELOAD_MODAL, false, {
                  root: true,
                });
                dispatch("openErrorModalFun", errorObj);
                // ampUtility.upiFailureEventAmp({
                //   eventAction: "DEEPLINK_ERROR",
                //   eventCategory: "UPI Failure",
                //   eventLabel: ""
                // })
              }
            }
          })
          .catch((err) => {
            console.log(
              " 16 16 16 16 16 -- process transaction api error - DEEP LINK",
              err
            );
            state.upiIntentConfig = {
              ...state.upiIntentConfig,
              upiTransactionError: false,
              eventAction: "DEEPLINK_ERROR: Deeplink not recieved from PayTM",
            };
            dispatch("openErrorModalFun", { isPopOpen: true });
            commit(keyMapsMutation.UPDATE_CIRCLE_RELOAD_MODAL, false, {
              root: true,
            });
          });
      } catch (error) {
        console.log(
          " 17 17 17 17 17 -- Api call in transaction -- DEEP LINK",
          error
        );
        dispatch("openErrorModalFun", { isPopOpen: true });
        commit(keyMapsMutation.UPDATE_CIRCLE_RELOAD_MODAL, false, {
          root: true,
        });
      } finally {
      }
    },
    getTransactionStatusApi({ commit, state, rootState, dispatch }, payload) {
      const {
        url,
        response,
        prcsTranPayload,
        prcsTranURL,
        orderTransactionId,
        paytm_pgPayload,
      } = payload;
      const { CHECKSUMHASH = "", MID = "", ORDERID = "" } = response || {};
      let tnxPayload = {
        MID: MID,
        ORDERID: ORDERID,
        CHECKSUMHASH: CHECKSUMHASH,
      };
      ApiCalls.PROCESS_TRANSACTION_API({
        headers: {},
        payload: prcsTranPayload,
        url: prcsTranURL,
      }).then((trnRes) => {
        if (trnRes?.data?.status == "TXN_SUCCESS") {
          dispatch("processTransaction", {
            data: paytm_pgPayload,
            TXNID: orderTransactionId,
          });
        } else {
          state.reloadIconPageTimerObj.nb = 1;
          state.reloadIconPageTimerObj.st = setInterval(() => {
            state.reloadIconPageTimerObj.nb += 1;
            try {
              ApiCalls.GET_TRANSACTION_STATUS_API({
                headers: { "content-type": "application/json;charset=UTF-8" },
                payload: tnxPayload || {},
                CUSTOM_URL: url || "",
              })
                .then((res) => {
                  if (res?.data?.STATUS == PAYMENT_STATUS.TXN_SUCCESS) {
                    commit(keyMapsMutation.UPDATE_CIRCLE_RELOAD_MODAL, false, {
                      root: true,
                    });
                    clearInterval(state.reloadIconPageTimerObj.st); // will stop the interval
                    const { TXNID = "" } = res?.data;
                    dispatch("processTransaction", {
                      data: res.data,
                      TXNID: orderTransactionId,
                    });
                  }
                })
                .catch((err) => {
                  console.log("19 19 19 19 19 -----", err);
                  commit(keyMapsMutation.UPDATE_CIRCLE_RELOAD_MODAL, false, {
                    root: true,
                  });
                  // ampUtility.upiFailureEventAmp({
                  //   eventAction: "PAYMENT_VERIFY_SERVICE_ERROR",
                  //   eventCategory: "UPI Failure",
                  //   eventLabel: JSON.stringify(err, Object.getOwnPropertyNames(err))
                  // })
                });
            } catch (error) {
              console.log("20 20 20 20 20", error);
              commit(keyMapsMutation.UPDATE_CIRCLE_RELOAD_MODAL, false, {
                root: true,
              });
              // ampUtility.upiFailureEventAmp({
              //   eventAction: "PAYMENT_VERIFY_SERVICE_ERROR",
              //   eventCategory: "UPI Failure",
              //   eventLabel: JSON.stringify(error, Object.getOwnPropertyNames(error))
              // })
            }
            // in case of modal close of circle loader timeout call should be terminated
            if (state.reloadIconPageTimerObj.nb > 59) {
              commit(keyMapsMutation.UPDATE_CIRCLE_RELOAD_MODAL, false, {
                root: true,
              });
              let errorObj = {
                bodyMsg:
                  "Your previous transaction has timed out. Please try again or retry with a different payment option",
                headerMsg: "Transaction timed out",
                delayTime: 20000,
              };
              // ampUtility.upiFailureEventAmp({
              //   eventAction: "UPI_TRANSACTION_TIMEOUT",
              //   eventCategory: "UPI Failure",
              //   errMsg: errorObj.bodyMsg,
              //   eventLabel: "UPI_TRANSACTION_TIMEOUT"
              // });
              dispatch("openErrorModalFun", errorObj);
              clearInterval(state.reloadIconPageTimerObj.st);
            }
          }, 5000);
        }
      });
    },
    stopReloadPageTimerInterval({ state, commit }) {
      clearInterval(state.reloadIconPageTimerObj.st);
    },
    openErrorModalFun({ commit, dispatch }, payload) {
      let defaultBodyMsg =
        "Sorry! This is not the experience we want to give you. We are working hard to fix it. Please retry in a few moments.";
      let content = {
        bodyMsg: payload.bodyMsg || defaultBodyMsg,
        headerMsg: payload.headerMsg || "Something went wrong !!",
        delayTime: payload.delayTime || 20000,
        isPopOpen: payload.isPopOpen || true,
      };
      commit("ErrorModal/updatePopContent", content, { root: true });
    },
    processTransaction({ commit, state, dispatch }, payload) {
      const orderTransactionId = payload.TXNID;
      let reqObj = payload.data;
      const formData = new FormData();
      Object.keys(reqObj).forEach((key) => formData.append(key, reqObj[key]));
      const data = Array.from(formData.entries())
        .map((set) => set.join("="))
        .join("&");

      state.upiIntentConfig = {
        ...state.upiIntentConfig,
        showConfirmationmessage: true,
      };
      try {
        ApiCalls.PROCESS_PAYMENT_API({
          headers: Headers(),
          payload: data || {},
        }).then((res) => {
          if (res?.data?.status == PAYMENT_STATUS.SUCCESS) {
            dispatch(
              keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
              { action: "Success" },
              { root: true }
            );
            state.upiIntentConfig = {}; // close upi intent flow call
            Utility.sendToThankYouScreen(orderTransactionId);
          } else {
            const { errors = [], error = [] } = res;
            state.upiIntentConfig = {
              ...state.upiIntentConfig,
              upiTransactionError: true,
              eventAction: "PROCESS_PAYMENT_RETURNED_ERROR",
            };
            const errorObj = {
              bodyMsg: errors[0]?.displayMsg || error[0]?.displayMsg || "",
            };
            dispatch("openErrorModalFun", errorObj);
            // ampUtility.upiFailureEventAmp({
            //   eventAction: "PROCESS_PAYMENT_RETURNED_ERROR",
            //   eventCategory: "UPI Failure",
            //   eventLabel: errorObj.bodyMsg
            // });
          }
        });
      } catch (error) {
        state.upiIntentConfig = {
          ...state.upiIntentConfig,
          upiTransactionError: true,
          eventAction: "PROCESS_PAYMENT_API_ERROR",
        };
        const errorObj = {
          bodyMsg:
            JSON.stringify(error, Object.getOwnPropertyNames(error)) || "",
        };
        dispatch("openErrorModalFun", errorObj);
        // ampUtility.upiFailureEventAmp({
        //   eventAction: "PROCESS_PAYMENT_API_ERROR",
        //   eventCategory: "UPI Failure",
        //   eventLabel: errorObj.bodyMsg
        // });
      }
    },
  },
};
